import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import Hero from './components/Hero/Hero';
import Projects from './components/Projects/Projects';
import Footer from './components/Footer/Footer';

let firstTime = true;
const scrollEvent = () => {
  
  function scrollHandler(e) {
    e.preventDefault();

    smoothScroll(e.deltaY);
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true;
      }
    }));
  } catch (e) {}

  var wheelOpt = supportsPassive ? {
    passive: false
  } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable
  function disableScroll() {
    window.addEventListener(wheelEvent, scrollHandler, wheelOpt); // modern desktop
  }

  disableScroll();
}

let winY = window.pageYOffset;
let scrollValue = 0;

function smoothScroll (delta) {
  if (
    firstTime ||
    window.pageYOffset <= 0 ||
    Math.abs((window.pageYOffset + window.innerHeight) - document.body.getBoundingClientRect().height) <= 1
  ) {
    winY = window.pageYOffset;
    scrollValue = 0;
    firstTime = false;
  }

  const offset = window.pageYOffset - winY;
  winY = window.pageYOffset;
  scrollValue -= offset;
  scrollValue += delta * 1.8;

  const settings = {
    duration: 800,
    smooth: 'easeOutQuad'
  };

  if (delta > 0) {
    scroll.scrollMore(scrollValue, settings);
  }
  else if (delta < 0) {
    scroll.scrollMore(scrollValue, settings);
  }
}

function App() {
  useEffect(scrollEvent, []);

  return (
    <React.Fragment>
      <Hero />
      <Projects />
      <Footer />
    </React.Fragment>
  );
}

export default App;
